import { render, staticRenderFns } from "./TaskGroup.vue?vue&type=template&id=370ec7db&scoped=true&"
import script from "./TaskGroup.vue?vue&type=script&lang=js&"
export * from "./TaskGroup.vue?vue&type=script&lang=js&"
import style0 from "./TaskGroup.vue?vue&type=style&index=0&id=370ec7db&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "370ec7db",
  null
  
)

export default component.exports